export default {
  state: {
    rightBranchesList: [],
    rightUsersList: {
      users: [],
      total: 0
    }
  },
  mutations: {
    setRightBranchesList: (state, { list }) => {
      state.rightBranchesList = list
    },
    setRightUsersList: (state, { list }) => {
      state.rightUsersList.total = list.total
      list.users.forEach((user) => {
        if (state.rightUsersList.users.some((el) => el.id === user.id)) {
          return
        }
        state.rightUsersList.users.push(user)
      })
    }
  },
  actions: {}
}
